<template>
  <t-layout :showNav="false">
    <div class="bankCard-page">
      <van-form validate-first>
        <van-cell-group class="bankCard_wrapper">
          <van-field
            label="姓名"
            class="input-wrap"
            v-model="person"
            clearable
            type="text"
            placeholder="请输入持卡人姓名"
            input-align="right"
          />

          <van-field
            label="卡号"
            class="input-wrap"
            v-model="cardNo"
            clearable
            type="text"
            placeholder="请输入带有“银联”标识的借记卡"
            input-align="right"
          />

          <van-field
            label="银行"
            class="input-wrap"
            v-model="bank"
            clearable
            type="text"
            placeholder="请输入银行名称：如招商银行"
            input-align="right"
          />

          <van-field
            label="手机号"
            class="input-wrap last-input"
            v-model="mobile"
            clearable
            maxlength="11"
            type="tel"
            placeholder="请输入手机号"
            input-align="right"
          />

          <div class="submit_btn_container">
            <van-button
              round
              class="submit_btn"
              @click="submitHandler"
              :loading="loading"
              loading-text="加载中..."
              >提交</van-button
            >
          </div>
        </van-cell-group>
      </van-form>
      <div class="tips">
        <div class="title">温馨提示</div>

        <p>1、领奖银行卡限带有银联标识的借记卡。</p>
        <p>2、手机号只作为客服联系方式预留，无需与银行卡绑定的号码一致。</p>
        <p>3、绑卡后，单注中奖金额低于(含)1万元的小奖，次日由平台自动派奖。</p>
      </div>
    </div>
  </t-layout>
</template>

<script>
import { Field, CellGroup, Form } from 'vant'
export default {
  name: 'bankCardView',
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form
  },
  data() {
    return {
      person: null,
      cardNo: null,
      bank: null,
      mobile: null,
      loading: false,

      user_coupon_id: null,
      url: '',
      info: {
        hasBind: false
      },
      tkn: ''
    }
  },
  created() {},
  activated() {
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '银行卡')

    const options = this.$route.query
    this.user_coupon_id = options.user_coupon_id
    this.getLotteryAddress('query', Number(this.user_coupon_id))
  },
  methods: {
    getLotteryAddress(type, user_coupon_id) {
      this.$api.coupon.getLotteryAddress({ type, user_coupon_id }).then(result => {
        let res = result.data
        if (res.code == 0) {
          const { url } = res.data
          this.url = url

          this.getLotteryBindBank()
        }
      })
    },

    getLotteryBindBank() {
      this.$api.coupon.getLotteryBindBank({ url: this.url }).then(result => {
        let res = result.data
        if (res.code == 0 && res.data) {
          this.info = res.data.ret

          if (!!this.info.hasBind) {
          }

          this.person = this.info.bank_user_name
          this.cardNo = this.info.bank_card_no
          this.bank = this.info.bank
          this.mobile = this.info.phone

          this.tkn = res.data.tkn
        }
      })
    },

    submitHandler() {
      if (this.loading) return

      if (!this.person) {
        this.$toast({
          duration: 2000,
          message: '请输入姓名'
        })
        return
      }
      if (!this.cardNo) {
        this.$toast({
          duration: 2000,
          message: '请输入正确银行卡号(16~19位数字)'
        })

        return
      }
      if (!this.bank) {
        this.$toast({
          duration: 2000,
          message: '请输入银行名称'
        })

        return
      }
      if (!this.mobile) {
        this.$toast({
          duration: 2000,
          message: '请输入手机号'
        })

        return
      }

      const params = {
        url: this.url,
        token: this.tkn,
        real_name: this.person,
        card_no: this.cardNo,
        bank_name: this.bank,
        phone: this.mobile
      }

      console.log('params', params)

      this.$toast({
        type: 'success',
        duration: 2000,
        message: '提交成功'
      })

      // setTimeout(() => {
      //   this.$router.back()
      // }, 1000)
      // return

      this.loading = true

      this.$api.coupon
        .postLotteryDoBindBank(params)
        .then(result => {
          let res = result.data
          if (res.code == 0) {
            this.$toast({
              type: 'success',
              duration: 2000,
              message: '提交成功'
            })

            setTimeout(() => {
              this.$router.back()
            }, 1000)
          } else {
            this.$toast({
              duration: 3000,
              message: res.msg || '未知错误'
            })
          }

          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.bankCard-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  padding: 22rpx 20rpx 20rpx;

  ::v-deep .van-field__control::-webkit-input-placeholder {
    color: #8c8c8c;
  }

  .van-cell::after {
    display: none !important;
  }

  .bankCard_wrapper {
    &::after {
      display: none !important;
    }

    .input-wrap {
      width: 100%;
      height: 96rpx;
      padding: 0 24rpx;
      display: flex;
      align-items: center;
      border-bottom: 2rpx solid #f5f5f5;
      color: #353738 !important;

      .input {
        flex: 1;
        display: block;
        width: 100%;
        height: 100%;
        padding-left: 24rpx;
        font-size: 26rpx;
      }

      &.last-input {
        border-bottom: 0;
      }
    }

    .submit_btn_container {
      margin-top: 40rpx;
      margin-bottom: 40rpx;

      .submit_btn {
        width: 100%;
        height: 96rpx;
        background: #ff5566;
        text-align: center;
        line-height: 96rpx;
        color: #ffffff;
        font-size: 34rpx;
        letter-spacing: 2rpx;
        border-radius: 0;
        border: 0;
        font-weight: 500;

        &.disabled {
          opacity: 0.5;
        }
      }
    }
  }

  .van-hairline--top-bottom::after {
    display: none;
  }

  .tips {
    padding: 40rpx 24rpx;
    .title {
      font-size: 26rpx;
      color: #353738;
      font-weight: 500;
      text-align: center;
      margin-bottom: 16rpx;
    }

    p {
      margin: 0;
      font-size: 26rpx;
      color: #8c8c8c;
      line-height: 42rpx;
    }
  }
}
</style>
